import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-zoom-in-entity',
  templateUrl: './zoom-in-entity.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZoomInEntityComponent implements OnInit {
  entity;
  information;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ZoomInEntityComponent>,
    public dialog: MatDialog,
    private datePipe: DatePipe,
  ) {}

  ngOnInit() {
    this.entity = this.data.entity;
  }

  close() {
    this.dialogRef.close();
  }

  getAge(dateOfBirth: string): number {
    return moment().diff(dateOfBirth, 'years', false);
  }

  getBasicInfo() {
    if (!this.entity || !this.entity.id) {
      return;
    }
    const first = this.entity.first_name ? this.entity.first_name : '';
    const middle = this.entity.middle_name ? this.entity.middle_name : '';
    const last = this.entity.last_name ? this.entity.last_name : '';
    const last2 = this.entity.last_name2 ? this.entity.last_name2 : '';
    const dob = this.entity.dob ? this.datePipe.transform(this.entity.dob, 'MM-dd-yyyy') : '';
    const dobDisplay = this.entity.dob
      ? this.datePipe.transform(this.entity.dob, 'MMM dd, yyyy')
      : '';
    switch (this.entity.entity_type) {
      case 'PATIENT':
        return (
          first +
          ' ' +
          middle +
          ' ' +
          last +
          ' ' +
          last2 +
          ' ' +
          (this.getAge(dob) > 0 ? '(' + this.getAge(dob) + ' yrs)' : '') +
          ' ' +
          dobDisplay
        );
      case 'DOCTOR':
        return first + ' ' + middle + ' ' + last + ' ' + last2;
      case 'CONTACT':
        return first + ' ' + middle + ' ' + last + ' ' + last2;
      case 'FACILITY':
        return this.entity.name ? this.entity.name : '';
      default:
        return first + ' ' + middle + ' ' + last + ' ' + last2;
    }
  }
}
